/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FirstName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function FirstName({
  children,
  viewPath = "/DesignSystem/SyncPatientMatchingCard/FirstName"
  
}) {
let cardPatientFirstnameValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'patient.firstName',
})
let cardMatchFirstnameValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'match.firstName',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsRed900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.900'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={!cardMatchFirstnameValueData ? dtColorsRed900 : dtColorsNeutral900}
 data="card.patient.firstName"
 text={cardPatientFirstnameValueData}
 data="card.match.firstName"
/>
{children}
</React.Fragment>)
}